"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = void 0;
const crypto_1 = require("crypto");
const destination_1 = require("./destination");
const ridUtils_1 = require("./ridUtils");
const timingEvent_1 = require("./timingEvent");
const ensureRid = (event) => {
    event.headers = event.headers || {};
    const rid = (0, ridUtils_1.getExistingRid)(event) || (0, crypto_1.randomUUID)();
    event.headers["x-ssky-rid"] = rid;
    return rid;
};
const apiKeyInfo = (event) => {
    let apiKey = event.headers["x-api-key"];
    let origin = event.headers["x-ssky-origin"];
    let parts = apiKey && apiKey.split(":");
    return {
        program: parts && parts[0],
        keyStage: parts && parts[1],
        origin: origin
    };
};
const millis = (hrtime) => {
    let nanoseconds = (hrtime[0] * 1e9) + hrtime[1];
    return nanoseconds / 1e6;
};
const logRecordToConsole = (record) => {
    // eslint-disable-next-line no-console
    console.log(record);
};
const eventLogger = (event, destination, loggingFunction) => {
    const message = `[${destination.pattern}]\t${JSON.stringify(event)}`;
    if (loggingFunction) {
        loggingFunction(message);
    }
    else {
        logRecordToConsole(message);
    }
};
/**
 * Starts an event object given name, rid, and additional data and logs it
 * @param {string} moduleName - the module Name to log with
 * @param {object} eventObject - optional object to hold whatever you want to help match start and end (usually rid)
 * @param {object} metaData - optional metadata to be added to the event
 * @param {object} loggingFunction - optional function to log a single record message. If not passed, records will be logged to console
 * @return {TimingEvent} a timed event object
 */
function start(moduleName, eventObject, metaData, loggingFunction) {
    return new timingEvent_1.TimingEvent(eventLogger, moduleName, eventObject, metaData, loggingFunction);
}
/**
 * Starts a log event usually given (but not limited to) a lambda handler event object
 * It will use rid and headers if they exist.
 * It will generate an rid (guid) and headers including "x-ssky-rid" if they don't exist - this will help match start and end events.
 * Example:
 * "rid": "101a02d3-40af-2ac8-9243-568bfb529a20",
 * "headers": {
 *      "x-ssky-rid": "101a02d3-40af-2ac8-9243-568bfb529a20"
 *      }
 * @param {string} moduleName - The component name
 * @param {object} eventObject - An event object for referencing start and end logs (string or { rid: "xxxx-xxxx-xxxx-xxxx", ...})
 * @param {object} metaData - optional metadata
 * @param {object} loggingFunction - optional function to log a single record message. If not passed, records will be logged to console
 * @return {TimingEvent} a timed event object
 */
function startRequest(moduleName, eventObject, metaData, loggingFunction) {
    // lowercase headers to standardize
    const headers = {};
    for (const key in eventObject.headers) {
        headers[key.toLowerCase()] = eventObject.headers[key];
    }
    eventObject.headers = headers;
    let startdata = Object.assign({ path: eventObject.path, query: eventObject.queryStringParameters, headers: eventObject.headers }, metaData);
    let rid = ensureRid(eventObject);
    let deployedStage = eventObject.requestContext && eventObject.requestContext.stage;
    let identity = Object.assign({ rid,
        deployedStage }, apiKeyInfo(eventObject));
    let timing = new timingEvent_1.TimingEvent(eventLogger, moduleName, identity, startdata, loggingFunction);
    // if we have apigateway information, add it as a stage to the data
    if (eventObject.requestContext && eventObject.requestContext.requestTimeEpoch) {
        // manually add the stage
        let gatewayStart = eventObject.requestContext.requestTimeEpoch; // hopefully in millis?
        let now = Date.now();
        let gateway = {
            start: gatewayStart - now,
            duration: now - gatewayStart
        };
        timing[timingEvent_1.addStage]("gateway", gateway);
    }
    return timing;
}
/**
 * Logs a single event
 * @param {string} moduleName - The module name to log
 * @param {object} metaData - Optional metdData to log with the event
 * @param {DESTINATION} destination - optional The destination of the stage
 * @default if destination is not present defaults to DESTINATION.All
 * @param {object} loggingFunction - optional function to log a single record message. If not passed, records will be logged to console
 */
const event = (moduleName, metaData, destination, loggingFunction) => {
    (0, destination_1.all)().filter(dest => dest.shouldUpdate(destination))
        .forEach(destination => {
        eventLogger(Object.assign({ event: moduleName, component: moduleName, start: millis(process.hrtime()) }, metaData), destination, loggingFunction);
    });
};
exports.events = {
    start,
    startRequest,
    event
};
//# sourceMappingURL=event.js.map